export default {
  chart: {
    height: 230,
    type: "donut",
  },
  labels: [],
  plotOptions: {
    pie: {
      donut: {
        size: "75%",
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: true,
  },
  colors: [
    "#f63e3e",
    "#eeb902",
    "#1cbb8c",
    "#5664d2",
    "#03d3fc",
    "#fc6f03",
    "#b2c8d9",
    "#c969be",
    "#03ffc4",
  ],
};
